// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"6e48dc13","74":"2a25f7bd","86":"579ac7a7","203":"b2dfba1f","215":"a9ede7d7","460":"ae4c86c0"}[chunkId] + ".chunk.css";
};